/* eslint-disable jsx-a11y/img-redundant-alt */
// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import Topbar from "../../components/Topbar/Topbar";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { checkPermission } from "../redux/api/PermissionManager";

const Amenities = () => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [amenity, setAmenity] = useState();
  const [popup, setPopup] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const [errors, setErrors] = useState(false);
  const inputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [totalCount, setTotalCount] = useState();
  const [totalPages, settotalPages] = useState();

  // ✅ Toggle status
  const handleStatus = async ({ id, status }) => {
    setLoading(true);
    const formdata = new FormData();
    // formdata.append("type", 1);
    formdata.append("status", !status);

    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetchCategories(page);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setLoading(false);
      toast.error("Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async (page = 1) => {
    try {
      const url = search
        ? `${URLS.MASTERURL}?type=${1}&search=${search}`
        : `${URLS.MASTERURL}?type=${1}&page=${page}`;

      const res = await get(url);

      setList(res?.results || res?.data || []);
      setTotalCount(res?.count);
      settotalPages(res?.total_pages);
      // Assuming your API paginates with 10 items per page
      const pageSize = 10;
      const lastPage = Math.ceil(res?.count / pageSize);

      setPagination({
        current_page: page,
        last_page: lastPage,
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCategories(page);
  }, [page, search]);

  const handleDelete = async () => {
    setPopup(false);
    setLoading(true);
    try {
      const res = await post(`${URLS.MASTERURL}${editId}/delete/`);
      console.log("res delete category", res);
      setEditId(null);
      fetchCategories(page);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!amenity) {
      setErrors(true);
    } else {
      setLoading(true);
      setErrors(false);
      const formdata = new FormData();
      formdata.append("type", 1);
      formdata.append("name", amenity);

      if (selectedImage && typeof selectedImage !== "string") {
        formdata.append("icon", selectedImage);
        console.log("formDataSSimage", selectedImage);
      }
      if (type === "edit" && editId) {
        console.log("update edit");

        try {
          const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
          console.log("res edit room category", res);
          setAmenity("");
          setSelectedImage(null);
          if (res.status === "success") {
            toast.success(res.message || "Edited successfully");
          } else {
            if (selectedImage && typeof selectedImage !== "string") {
              toast.error(
                res.message ||
                  "Failed to update. Please try again. \nMax Upload Size: 5MB | Banner Size: 1200px × 700px"
              );
            }
          }
          fetchCategories(page);
          setLoading(false);
        } catch (err) {
          console.error(err);
          if (selectedImage && typeof selectedImage !== "string") {
            toast.error(
              err?.response?.data?.message ||
                "Failed to update. Please try again. \nMax Upload Size: 5MB | Banner Size: 1200px × 700px"
            );
          }
          setLoading(false);
        } finally {
          setLoading(false);
        }
      } else {
        formdata.append("status", true);
        try {
          const res = await post(`${URLS.MASTERURL}add/`, formdata);
          console.log("res post", res);
          setAmenity("");
          setSelectedImage(null);
          if (res.status === "success") {
            toast.success(res.message || "Added successfully");
          } else {
            if (selectedImage && typeof selectedImage !== "string") {
              toast.error(
                res.message ||
                  "Failed to update. Please try again. \nMax Upload Size: 5MB | Banner Size: 1200px × 700px"
              );
            }
          }
          fetchCategories(page);
          setLoading(false);
        } catch (err) {
          console.error(err);
          if (selectedImage && typeof selectedImage !== "string") {
            toast.error(
              err?.response?.data?.message ||
                "Failed to update. Please try again. \nMax Upload Size: 5MB | Banner Size: 1200px × 700px"
            );
          }
          setLoading(false);
        } finally {
          setLoading(false);
        }
      }
      setAddPopup(false); // or API call here
    }
  };

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };
  const handleImageClick = () => {
    inputRef.current.click();
  };

  console.log("totalCount", totalCount);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: " Icon",
        accessor: "icon",
        Cell: ({ value, row }) => {
          return (
            <img src={value || dummyimage} alt="image" className="list-img" />
          );
        },
      },
      {
        Header: " Amenities",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (checkPermission("CAN-STATUS-AMENITIES")) {
                    handleStatus(row.original);
                  }
                }}
                className={`${
                  value === false ? "deactive-btn" : "active-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value === false ? "De-active" : " Active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {checkPermission("CAN-EDIT-AMENITIES") && (
                  <button
                    onClick={() => {
                      setAddPopup(true);
                      setType("edit");
                      setEditId(row.original.id);
                      setAmenity(row.original?.name);
                      setSelectedImage(row.original?.icon);
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-DELETE-AMENITIES") && (
                  <button
                    onClick={() => {
                      setPopup(true);
                      setEditId(row.original.id);
                    }}
                    // onClick={() => setDeletePopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div>
      <Topbar header={"Master"} subHead={"Amenities"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total: {totalCount || list.length}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img alt="" src={Search_icon} className="search" />
          </div>
          {checkPermission("CAN-ADD-AMENITIES") && (
            <button
              onClick={() => {
                setAddPopup(true);
                setType("add");
                setAmenity("");
              }}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
            >
              {" "}
              + Add New
            </button>
          )}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        totalPages={totalPages}
        show={true}
      />
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {type === "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setSelectedImage("");
                  setErrors("");
                  setAmenity("");
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-4">
              <div className="col-md-4">
                <p className="f3 text-start fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Icon
                </p>
                <div className=" mb-2 w-100 d-flex ac-jb">
                  <div
                    onClick={handleImageClick}
                    className="position-relative w-100"
                  >
                    <div className="d-flex ac-jb w-100">
                      <div>
                        {typeof selectedImage === "string" ? (
                          <img
                            alt="not found"
                            style={{
                              width: "70px",
                              height: "60px",
                              borderRadius: "10px",
                            }}
                            src={selectedImage ? selectedImage : dummyimage}
                          />
                        ) : selectedImage?.name ? (
                          <img
                            alt="not found"
                            style={{
                              width: "70px",
                              height: "60px",
                              borderRadius: "10px",
                            }}
                            src={URL.createObjectURL(selectedImage)}
                          />
                        ) : (
                          <img
                            alt="not found"
                            style={{
                              width: "70px",
                              height: "60px",
                              borderRadius: "10px",
                            }}
                            src={dummyimage}
                          />
                        )}
                        <input
                          style={{
                            position: "absolute",
                            width: "70px",
                            height: "60px",
                            left: "0px",
                            top: "0px",
                          }}
                          type="file"
                          hidden
                          name="myImage"
                          accept="image/*"
                          ref={inputRef}
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                  Amenities Name
                </p>
                <input
                  className="input-box"
                  name="userName"
                  value={amenity}
                  onChange={(e) => {
                    // Remove any number characters before updating state
                    const value = e.target.value.replace(/[0-9,]/g, "");
                    setAmenity(value);
                  }}
                  type="text"
                  placeholder="Name"
                />

                {errors && <p className="err text-start">Add Amenity</p>}
              </div>
            </div>
            {selectedImage !== "edit" && (
              <h4 className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ms-2">
                Max Upload Size : 5MB and Banner Size 1200px 700px*
              </h4>
            )}

            <div className="d-flex ac-jc px-2 mt-5">
              <button
                onClick={() => {
                  handleSubmit();
                  setPopup(false);
                  // logout();
                }}
                className="submit-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}{" "}
                {type === "add" ? "Add" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDelete} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && <Loader />}
    </div>
  );
};

export default Amenities;
